var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarehouse = function SvgWarehouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "warehouse_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#warehouse_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 5.15-8 3.2V19h2v-6q0-.824.588-1.413A1.93 1.93 0 0 1 8 11h8q.824 0 1.413.587Q18 12.175 18 13v6h2V8.35zM2 19V8.35q0-.625.337-1.125.338-.5.913-.725l8-3.2q.35-.15.75-.15t.75.15l8 3.2q.575.225.913.725.337.5.337 1.125V19q0 .825-.587 1.412A1.93 1.93 0 0 1 20 21h-4v-8H8v8H4q-.824 0-1.412-.588A1.93 1.93 0 0 1 2 19m7 2v-2h2v2zm2-3v-2h2v2zm2 3v-2h2v2z"
  }))));
};
export default SvgWarehouse;